import type { FC, PropsWithChildren, ReactNode } from 'react';
import type { ResetTuneProps } from '@/components/deviceTunes/interfaces.ts';

import { IconButton, Tooltip } from '@mui/material';

import RestartAltIcon from '@mui/icons-material/RestartAlt';

import { useDefaultsResetter } from './useDefaultsResetter';
import { ConfirmationDialog } from '@/components/modals/confirmationDialog/ConfirmationDialog.tsx';

export const ResetButtonWithConfirmation: FC<PropsWithChildren<ResetTuneProps>> = (props: ResetTuneProps) => {
  const { areDefault, resetter } = useDefaultsResetter(props.descriptors);

  return (
    <Tooltip title={props.label + ' to default'} placement="left" arrow={true}>
      <span>
        <ConfirmationDialog
          title=""
          primaryActionText={'RESET'}
          description={`Are you sure you want to ${props.label.toLowerCase()} to default?`}
          response={(): void => resetter.doReset()}
        >
          {(showDialog): ReactNode => (
            <IconButton
              onClick={showDialog}
              size="medium"
              aria-labelledby="reset-button"
              disabled={areDefault}
              data-testid="resetBtn"
            >
              <RestartAltIcon />
            </IconButton>
          )}
        </ConfirmationDialog>
      </span>
    </Tooltip>
  );
};
